import {
  IReverseGeocode,
  IPOISearch,
  IResult,
  IRoutePlan,
  IRoadNetwork,
  IBoundary,
  IGeocode
} from "@/types/map";
import axios from "axios";

export default class bdWebAPIRequest {
  constructor() {}

  public static async requestPOI(params: IPOISearch): Promise<IResult> {
    const searchType = params.searchType || "circle";
    const query = params.searchName;
    const searchTag = params.searchTag || "";
    const requestPage = params.searchPage || 1;
    const serverAddr = params.serverAddr || "http://51.196.2.96:8219";
    let resultDate = null;

    if (!query) {
      return {
        status: 0,
        message: "please input search name first!"
      };
    }
    let city: string = "",
      district: string,
      path: number[][],
      location: number[],
      radius: number;
    if (searchType === "region") {
      city = params.city || "凉山彝族自治州"; //目前只支持京津冀
      district = params.district || "";

      const requestUrl =
        serverAddr +
        `/search?` +
        `q=${query}` +
        // `region=${city}` +
        `&city=${city}` +
        `&district=${district}` +
        `&output=json` +
        `&tag=${searchTag}` +
        "&city_limit=true" +
        `&page_num=${requestPage}` +
        `&page_size=100`;

      await axios
        .get(requestUrl)
        .then(function(response) {
          resultDate = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    } else if (searchType === "rect") {
      path = params.paths || [];
      let bounds =
        Math.min(path[3][1], path[1][1]) +
        "," +
        Math.min(path[3][0], path[1][0]) +
        "," +
        Math.max(path[3][1], path[1][1]) +
        "," +
        Math.max(path[3][0], path[1][0]);
      const requestUrl =
        serverAddr +
        `/search?` +
        //`location=${location[1]},${location[0]}` +
        `&q=${query}` +
        //`&radius=${radius}` +
        `&bounds=${bounds}` +
        `&sort_rule=0` +
        `&output=json` +
        `&tag=${searchTag}` +
        "&radius_limit=true" +
        `&page_num=${requestPage}` +
        `&page_size=100`;
      await axios
        .get(requestUrl)
        .then(function(response) {
          resultDate = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    } else if (searchType === "polygon") {
      let str: any[] = [];
      path = params.paths || [];
      for (var i = 0; i < path.length; i++) {
        str.push(path[i][1] + "," + path[i][0]);
      }
      let xys = str.join(";");
      const requestUrl =
        serverAddr +
        `/search?` +
        //`location=${location[1]},${location[0]}` +
        `&q=${query}` +
        //`&radius=${radius}` +
        `&xys=${xys}` +
        `&sort_rule=0` +
        `&output=json` +
        `&tag=${searchTag}` +
        "&radius_limit=true" +
        `&page_num=${requestPage}` +
        `&page_size=100`;
      await axios
        .get(requestUrl)
        .then(function(response) {
          resultDate = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    } else if (searchType === "circle") {
      location = params.location || [];
      radius = params.radius || 1000;

      const requestUrl =
        serverAddr +
        `/search?` +
        `location=${location[1]},${location[0]}` +
        `&q=${query}` +
        `&radius=${radius}` +
        `&sort_rule=0` +
        `&output=json` +
        `&tag=${searchTag}` +
        "&radius_limit=true" +
        `&page_num=${requestPage}` +
        `&page_size=100`;
      await axios
        .get(requestUrl)
        .then(function(response) {
          resultDate = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    } else if (searchType === "roadCross") {
      const requestUrl =
        serverAddr +
        `/search?` +
        `query_type=roadcross` +
        `&q=${query}` +
        `&output=json` +
        `&scope=2` +
        `&radius_limit=true` +
        `page_num=${requestPage}` +
        `page_size=100`;
      await axios
        .get(requestUrl)
        .then(function(response) {
          resultDate = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    } else {
      return {
        status: 0,
        message: "check out the value of searchType!"
      };
    }

    return {
      status: 0,
      result: resultDate,
      message: "成功调用！"
    };
  }

  public static async requestRoadPlan(params: IRoutePlan): Promise<IResult> {
    const destination = params.destination;
    const origin = params.origin;
    const midPoints = params.midPoints;
    const route = params.changeRoute || "ordinary";
    const mode = params.mode || "CAR";
    const avoidArea = params.avoidArea;
    const serverAddr = params.serverAddr || "http://51.196.2.96:8219";
    const tactics =
      route === "shortest time" ? 1 : route === "shortest distance" ? 2 : 1;

    let midPointsToString = ``;
    if (midPoints && midPoints.length) {
      midPoints.forEach((midPt: number[]) => {
        midPointsToString += `${midPt[1]},${midPt[0]}|`;
      });
    }
    let result = await axios.get(serverAddr + "/cloudsearch", {
      params: {
        action: "route",
        destination: `${destination[1]},${destination[0]}`,
        details: "true",
        index: "direction",
        mode: "CAR",
        origin: `${origin[1]},${origin[0]}`,
        output: "json",
        tactics: `${tactics}`,
        waypoints: midPointsToString
      }
    });
    let results = result.data.results;
    return {
      status: 0,
      message: "not complete"
    };
  }
  //用处有限，参数模糊
  public static async requestGeocode(
    params: IReverseGeocode
  ): Promise<IResult> {
    const location = params.location;
    const radius = params.radius || 500;
    const poi_types = params.poiTypes || [];
    const serverAddr = params.serverAddr || "http://51.196.2.96:8219";
    let poiTypes: string = "";
    if (poi_types.length) {
      poi_types.forEach((poi_type: string, index: number) => {
        if (index < poi_type.length - 1) {
          poiTypes += poi_type + "|";
        } else {
          poiTypes += poi_type;
        }
      });
    }

    axios
      .get(
        serverAddr + "/geocoding?poi_types=酒店&location=39.904844,116.382225",
        {
          params: {
            location: `${location[1]},${location[0]}`,
            radius: `${radius}`,
            // poi_types: `${poiTypes}`,
            // poi_types: `酒店`,
            extensions_road: `${poi_types.indexOf("道路") > -1}`,
            extensions_poi: `${poi_types.length > 0 ? 1 : 0}`,
            output: "json"
          }
        }
      )
      .then((value: any) => {});

    return {
      status: 0,
      message: "not complete"
    };
  }

  public static async requestPOIByUID(): Promise<IResult> {
    return {
      status: 0,
      message: "not complete"
    };
  }

  public static async requestRoadNetwork(
    params: IRoadNetwork
  ): Promise<IResult> {
    const searchName = params.searchName;
    if (!searchName || typeof searchName !== "string") {
      return {
        status: 0,
        message: "searchName is required and must be type of string!"
      };
    }
    const province = params.province || "四川省";
    const city = params.city || "凉山彝族自治州";
    const serverAddr = params.serverAddr || "http://51.196.2.96:8219";
    let resultDate = null;
    const requestUrl =
      serverAddr +
      `/road?` +
      `q=${searchName}` +
      `&province=${province}` +
      `&city=${city}` +
      `&output=json`;
    await axios
      .get(requestUrl)
      .then(function(response) {
        resultDate = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    return {
      status: 0,
      message: "成功调用改方法！",
      result: resultDate
    };
  }

  public static async requestBoundary(params: IBoundary): Promise<IResult> {
    const queryName = params.searchName;
    const adcode = params.adcode || "";
    const serverAddr = params.serverAddr || "http://51.196.2.96:8219";
    console.log("requestBoundary serverAddr=", serverAddr);
    const requestUrl =
      serverAddr +
      `/boundary?` +
      `adcode=${adcode}` +
      `&q=${queryName}` +
      `&output=json`;
    let resultDate = null;
    await axios
      .get(requestUrl)
      .then(function(response) {
        //console.log("requestBoundary response==",response);
        resultDate = response.data;
        //console.log("resultDate==",resultDate);
        //resultDate = response.results;
      })
      .catch(function(error) {
        console.log(error);
      });
    return {
      status: 0,
      message: "成功调用该方法！",
      result: resultDate
    };
  }
}
